import { React, useState } from "react";

function Order_profile() {
    const [details, setDetails] = useState();
    const [showPopup, setshowPopup] = useState(false);

    const orderHandle = (orderId) => {
        document.querySelector('.modal').classList.add('active');
        setshowPopup(true);
    };

    const closeHandle = () => {
        document.querySelector('.modal').classList.remove('active');
        setshowPopup(false);
    }

    return (
        <>
            <h2 className="titleTab">سفارش های من</h2>
            <ul className="orderStatus">
                <li>جاری</li>
                <li className="active">پایان یافته</li>
                <li>کنسل شده</li>
            </ul>
            <div className="orders">
                <div className="order">
                    <div className="order-right">
                        <p className="order-status order-item">
                            <i className="fas fa-check"></i>
                            <span className="value">پایان یافته</span>
                        </p>
                        <p className="order-code order-item">
                            <span className="name">کد سفارش : </span>
                            <span className="value">309631271</span>
                        </p>
                        <p className="order-date order-item">
                            <span className="name">تاریخ : </span>
                            <span className="value">۲۰ اردیبهشت ۱۴۰۰</span>
                        </p>
                    </div>
                    <div className="order-left">
                        <button onClick={orderHandle} name="showOrder" className="showOrder" type="button">مشاهده فاکتور</button>
                    </div>
                </div>
                <div className="order">
                    <div className="order-right">
                        <p className="order-status order-item">
                            <i className="fas fa-check"></i>
                            <span className="value">پایان یافته</span>
                        </p>
                        <p className="order-code order-item">
                            <span className="name">کد سفارش : </span>
                            <span className="value">309631271</span>
                        </p>
                        <p className="order-date order-item">
                            <span className="name">تاریخ : </span>
                            <span className="value">۲۰ اردیبهشت ۱۴۰۰</span>
                        </p>
                    </div>
                    <div className="order-left">
                        <button name="showOrder" className="showOrder" type="button">مشاهده فاکتور</button>
                    </div>
                </div>
                <div className="order">
                    <div className="order-right">
                        <p className="order-status order-item">
                            <i className="fas fa-check"></i>
                            <span className="value">پایان یافته</span>
                        </p>
                        <p className="order-code order-item">
                            <span className="name">کد سفارش : </span>
                            <span className="value">309631271</span>
                        </p>
                        <p className="order-date order-item">
                            <span className="name">تاریخ : </span>
                            <span className="value">۲۰ اردیبهشت ۱۴۰۰</span>
                        </p>
                    </div>
                    <div className="order-left">
                        <button name="showOrder" className="showOrder" type="button">مشاهده فاکتور</button>
                    </div>
                </div>
                <div className="order">
                    <div className="order-right">
                        <p className="order-status order-item">
                            <i className="fas fa-check"></i>
                            <span className="value">پایان یافته</span>
                        </p>
                        <p className="order-code order-item">
                            <span className="name">کد سفارش : </span>
                            <span className="value">309631271</span>
                        </p>
                        <p className="order-date order-item">
                            <span className="name">تاریخ : </span>
                            <span className="value">۲۰ اردیبهشت ۱۴۰۰</span>
                        </p>
                    </div>
                    <div className="order-left">
                        <button name="showOrder" className="showOrder" type="button">مشاهده فاکتور</button>
                    </div>
                </div>
                <div className="order">
                    <div className="order-right">
                        <p className="order-status order-item">
                            <i className="fas fa-check"></i>
                            <span className="value">پایان یافته</span>
                        </p>
                        <p className="order-code order-item">
                            <span className="name">کد سفارش : </span>
                            <span className="value">309631271</span>
                        </p>
                        <p className="order-date order-item">
                            <span className="name">تاریخ : </span>
                            <span className="value">۲۰ اردیبهشت ۱۴۰۰</span>
                        </p>
                    </div>
                    <div className="order-left">
                        <button name="showOrder" className="showOrder" type="button">مشاهده فاکتور</button>
                    </div>
                </div>
            </div>
            <div className={showPopup ? 'active popup' : 'popup'} >
                <span className="close" onClick={closeHandle}>
                    <svg width="28" height="28" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
                        <path fill="#676767" fillRule="evenodd" d="M11.2929,3.29289 C11.6834,2.90237 12.3166,2.90237 12.7071,3.29289 C13.0976,3.68342 13.0976,4.31658 12.7071,4.70711 L9.41421,8 L12.7071,11.2929 C13.0976,11.6834 13.0976,12.3166 12.7071,12.7071 C12.3166,13.0976 11.6834,13.0976 11.2929,12.7071 L8,9.41421 L4.70711,12.7071 C4.31658,13.0976 3.68342,13.0976 3.29289,12.7071 C2.90237,12.3166 2.90237,11.6834 3.29289,11.2929 L6.58579,8 L3.29289,4.70711 C2.90237,4.31658 2.90237,3.68342 3.29289,3.29289 C3.68342,2.90237 4.31658,2.90237 4.70711,3.29289 L8,6.58579 L11.2929,3.29289 Z" />
                    </svg>
                </span>
                <div className="popup_header">
                    <img src={process.env.PUBLIC_URL + '/images/invoice.svg'} className="img-fluid" alt="" title="" width="64" />
                    <p className="popup_header_title">فاکتور سفارش شما</p>
                </div>
                <div className="popup_content">
                    <p className="popup_item">
                        <span className="name">
                            کباب کوبیده (یک سیخ)
                        </span>
                        <span className="price">
                            <small className="count">x4</small>
                            40,000
                            <span className="currency">تومان</span>
                        </span>
                    </p>
                    <p className="popup_item">
                        <span className="name">
                            گوجه کبابی (یک سیخ)
                        </span>
                        <span className="price">
                            <small className="count">x1</small>
                            10,000
                            <span className="currency">تومان</span>
                        </span>
                    </p>
                    <p className="popup_item total_order">
                        <span className="name">
                            جمع سفارشات
                        </span>
                        <span className="price">
                            50,000
                            <span className="currency">تومان</span>
                        </span>
                    </p>
                    <p className="popup_item order_recive">
                        <span className="name">
                            هزینه ارسال
                        </span>
                        <span className="price">
                            9,000
                            <span className="currency">تومان</span>
                        </span>
                    </p>
                </div>
                <div className="popup_footer">
                    <p className="total_price">
                        <span className="name">مجموع هزینه</span>
                        <span className="price">
                            59,000
                            <span className="currency">تومان</span>
                        </span>
                    </p>
                </div>
            </div>
            <div className="modal" onClick={closeHandle}></div>
        </>
    );

}

export default Order_profile;